import { localizations } from "@msuite/utils/locales";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export { localized } from "./localized-string";

i18n.use(initReactI18next).init(localizations);

export type { TranslationFn } from "./use-translation";
export * from "./use-translation";
export { i18n };
